module.exports = __webpack_public_path__ + "img/length2.4bbb5651.png";